import { createContext, useContext } from 'react'

const hostnameContext = createContext({
  defaultLeadsHostname: 'unknown',
  apiHostname:          'unknown',
  portalHostname:       'unknown',
  complyedHostname:     'unknown',
})

export default function HostnameProvider({ children, apiHostname, defaultLeadsHostname, portalHostname, complyedHostname }) {
  return (
    <hostnameContext.Provider value={{ apiHostname, defaultLeadsHostname, portalHostname, complyedHostname }}>
      {children}
    </hostnameContext.Provider>
  )
}

export function useHostname() {
  return useContext(hostnameContext)
}
